import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  makeStyles,
  TextField,
  Typography,
} from "@material-ui/core";
import React, { useState } from "react";
import Transition from "../../stateless/Transition";
import styles from "../../../styles/global-styles";
import { ConfirmButtons } from "../../stateless/ConfirmButtons";
import NumberFormatCustom from "../../stateless/NumberFormatCustom";
import { connect } from "react-redux";
import { actions } from "../../../redux/actions/alert";

const useStyles = makeStyles((theme) => ({
  label: {
    marginBottom: "1.5vh",
  },
  box: {
    marginTop: "20px",
  },
  formControl: styles.globalFormControl,
  body: styles.body,
}));

const UpdatePriceForDistribution = ({
  onClose,
  open,
  barCode,
  updatePrice,
  quantity,
  detailAlert,
  addAlert,
}) => {
  const classes = useStyles();

  const [price, setPrice] = useState("");

  const handleSubmitForm = async () => {
    if (price !== "") {
      updatePrice(price, barCode, quantity);
      onClose();
    } else {
      addAlert({ showAlert: true });
      detailAlert({
        severity: "warning",
        message: "Ingresar el valor del precio a actualizar",
        time: 2800,
      });
    }
  };

  const handleInputText = ({ target: { value } }) => {
    setPrice(value);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      keepMounted
      TransitionComponent={Transition}
      aria-labelledby="simple-dialog-title"
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle id="simple-dialog-title" style={{ textAlign: "center" }}>
        Actualizar precio
      </DialogTitle>
      <DialogContent>
        <Grid container direction="column" justify="center" alignItems="center">
          <Grid item className={classes.body}>
            Accesorios seleccionados {quantity}
          </Grid>
          <Grid item>
            <Box className={classes.box}>
              <Typography
                variant="body2"
                component={"div"}
                className={classes.label}
              >
                Precio
              </Typography>
              <TextField
                name="price"
                value={price}
                onChange={(e) => handleInputText(e)}
                variant="outlined"
                InputProps={{
                  inputComponent: NumberFormatCustom,
                }}
              />
            </Box>
          </Grid>

          <ConfirmButtons
            handleSubmitForm
            cancel={() => onClose()}
            accept={handleSubmitForm}
            acceptTitle="Actualizar"
          />
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

const dispatch = {
  detailAlert: actions.detailAlert,
  addAlert: actions.addAlert,
};

export default connect(null, dispatch)(UpdatePriceForDistribution);
